/** @module Enums */ /** typedoc */
/**
 * Style used to master.
 */
var MasteringStyleEnum;
(function (MasteringStyleEnum) {
    MasteringStyleEnum["Warm"] = "PS1";
    MasteringStyleEnum["Balanced"] = "PS2";
    MasteringStyleEnum["Open"] = "PS3";
    MasteringStyleEnum["Reference"] = "PS4";
})(MasteringStyleEnum || (MasteringStyleEnum = {}));

export { MasteringStyleEnum };
